import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const reviewText: ThemedFunctor = ({ theme }) => css`
  background-color: ${theme.palettes.neutrals.lighter};
  padding: 1rem;
  border-radius: 0.438rem;
`;
